document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-xsquo-marketplace-header]').forEach((header) => {
    const hideOnScroll = header.dataset.hideBarOnScroll === 'true';

    let lastY = window.scrollY;
    let scrollUpDistance = 0;
    let scrollDownDistance = 0;
    let ticking = false;

    const HIDE_AFTER = 110;
    const MIN_DISTANCE = 18;

    if (hideOnScroll) {
      const handleScroll = () => {
        const currentY = Math.max(window.scrollY, 0);
        const delta = currentY - lastY;

        /*
         * Ignoramos microdesplazamientos.
         * Esto evita que el propio cambio del header
         * provoque un bucle mostrar/ocultar.
         */
        if (Math.abs(delta) < 2) {
          lastY = currentY;
          ticking = false;
          return;
        }

        if (delta > 0) {
          // Bajando
          scrollDownDistance += delta;
          scrollUpDistance = 0;

          if (
            currentY > HIDE_AFTER &&
            scrollDownDistance >= MIN_DISTANCE &&
            !header.classList.contains('is-bar-hidden')
          ) {
            header.classList.add('is-bar-hidden');
            scrollDownDistance = 0;
          }
        } else {
          // Subiendo
          scrollUpDistance += Math.abs(delta);
          scrollDownDistance = 0;

          if (
            scrollUpDistance >= MIN_DISTANCE &&
            header.classList.contains('is-bar-hidden')
          ) {
            header.classList.remove('is-bar-hidden');
            scrollUpDistance = 0;
          }
        }

        // Al volver arriba, la barra siempre aparece
        if (currentY <= 30) {
          header.classList.remove('is-bar-hidden');
          scrollUpDistance = 0;
          scrollDownDistance = 0;
        }

        lastY = currentY;
        ticking = false;
      };

      window.addEventListener(
        'scroll',
        () => {
          if (!ticking) {
            window.requestAnimationFrame(handleScroll);
            ticking = true;
          }
        },
        { passive: true }
      );
    }

    /*
     * Cerrar menú al hacer clic fuera
     */
    document.addEventListener('click', (event) => {
      header.querySelectorAll('details[open]').forEach((details) => {
        if (!details.contains(event.target)) {
          details.removeAttribute('open');
        }
      });
    });

    /*
     * Cerrar menú con ESC
     */
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        header.querySelectorAll('details[open]').forEach((details) => {
          details.removeAttribute('open');
        });
      }
    });
  });
});